import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Relegation } from '@sorare/core/src/atoms/icons/Relegation';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineM, LabelL } from '@sorare/core/src/atoms/typography';

import { GridBackground } from '@sorare/gameplay/src/components/rivals/GridBackground';
import { BackgroundAligned } from '@sorare/gameplay/src/components/rivals/GridBackground/BackgroundAligned';
import { GridDivWithBorder } from '@sorare/gameplay/src/components/rivals/GridBackground/GridDivWithBorder';

const StyledGridBackground = styled(GridBackground)`
  flex: 1;
`;

const StyledGridDivWithBorder = styled(GridDivWithBorder)`
  background: rgba(var(--c-rgb-red-600), 0.15);
  backdrop-filter: blur(30px);
`;

type Props = {
  inactivity: boolean;
};
export const NoLeaderboardEmptyState = ({ inactivity }: Props) => {
  return (
    <StyledGridBackground height="auto" color="#777777">
      <BackgroundAligned horizontalDelta={0} verticalDelta={-0.5}>
        <Vertical gap={2} center>
          <StyledGridDivWithBorder borderColor="var(--c-red-600)">
            {inactivity ? (
              <Relegation width={36} height={36} hideBorders />
            ) : (
              <FontAwesomeIcon
                icon={faXmark}
                size="2x"
                color="var(--c-red-600)"
              />
            )}
          </StyledGridDivWithBorder>
          <Vertical gap={0.5} center>
            <HeadlineM>
              {inactivity ? (
                <FormattedMessage
                  id="NoLeaderboardEmptyState.inactivity"
                  defaultMessage="Relegated"
                />
              ) : (
                <FormattedMessage
                  id="NoLeaderboardEmptyState.title"
                  defaultMessage="Not entered"
                />
              )}
            </HeadlineM>
            {inactivity && (
              <LabelL color="var(--c-nd-700)">
                <FormattedMessage
                  id="NoLeaderboardEmptyState.relagationReason"
                  defaultMessage="Due to inactivity"
                />
              </LabelL>
            )}
          </Vertical>
        </Vertical>
      </BackgroundAligned>
    </StyledGridBackground>
  );
};
